module.exports = __webpack_public_path__ + "static/media/weight-loss-doctor-news.ffb5e599.jpg";